// extracted by mini-css-extract-plugin
export var dataCell = "_qo-2";
export var dataRow = "_qo-0";
export var headerRow = "_qo-1";